module.exports = __webpack_public_path__ + "img/hero-3.9b28eda0.jpeg";